export enum CopyMode {
    Undefined = 0,
    LooseCopy = 1,
    ManagedCopy = 2
}

export enum ActivityLogCopyMode {
    LooseCopy = 0,
    ManagedCopy = 1
}
